<template>
  <div class="container mt-5">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header bg-dark text-light d-flex align-items-center">
          <button class="btn btn-dark btn-sm" @click="$router.push('/')">
            <i class="fa fa-arrow-left"></i>
          </button>
          <h4 class="ml-3" v-if="user">Create customer</h4>
          <h4 class="ml-3" v-else>Join Subscription</h4>
        </div>
        <div class="card-body">
          <form @submit.prevent="validateAndAccept">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label for="title">First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="membership.fname"
                    required
                    placeholder="First Name"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label for="title">Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="membership.lname"
                    placeholder="Last Name"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div
                :class="`col-sm-12 col-md-${
                  refered_by === 'advertisement' ? '4' : '6'
                }`"
              >
                <div class="form-group">
                  <label for="title">Referred By</label>
                  <select class="form-control" v-model="refered_by">
                    <option
                      v-for="item in selectedByList"
                      :value="item.value"
                      :key="item.name"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                :class="`col-sm-12 col-md-4`"
                v-if="refered_by === 'advertisement'"
              >
                <div class="form-group">
                  <label for="title">Referred By</label>
                  <select class="form-control" v-model="adItem">
                    <option
                      v-for="item in itemsAd"
                      :value="item.value"
                      :key="item.name"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                :class="`col-sm-12 col-md-${
                  refered_by === 'advertisement' ? '4' : '6'
                }`"
              >
                <div class="form-group">
                  <label for="title"
                    >{{
                      refered_by == "sales_rep" ? "Sales Rep" : "Other"
                    }}
                    Name</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    :disabled="refered_by == '' ? true : false"
                    :required="refered_by != '' ? true : false"
                    v-model="refered_by_name"
                    placeholder="Enter Name"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label for="email">{{ $t("support.email") }}</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="membership.email"
                    id="email"
                    placeholder="Enter Email"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6 row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="">Date Of Birth</label>
                    <select class="form-control" required v-model="year">
                      <option value="">Year</option>
                      <option v-for="year in getYear" :key="year" :value="year">
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for=""></label>
                    <select class="form-control mt-2" required v-model="month">
                      <option value="">Month</option>
                      <option
                        v-for="month in getMonth"
                        :key="month"
                        :value="month"
                      >
                        {{ month }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for=""></label>
                    <select class="form-control mt-2" required v-model="day">
                      <option value="">Day</option>
                      <option v-for="day in getDay" :key="day" :value="day">
                        {{ day }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- <div class="form-group">
                  <label>Date of birth</label>
                  <DatePicker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    type="date"
                    placeholder="Select DOB"
                    v-model="membership.dob"
                    value-type="timestamp"
                  />
                </div> -->
              </div>
            </div>

            <div class="form-group">
              <label class="lable">{{ $t("support.phone") }}</label>
              <div class="input-group mt-1">
                <div
                  class="input-group-prepend addinput"
                  style="border-radius: 13px 0px 0px 13px"
                >
                  <vue-country-code
                    @onSelect="changeCountryCode"
                    :onlyCountries="['us']"
                    :disabledFetchingCountry="true"
                  >
                  </vue-country-code>
                </div>
                <input
                  type="number"
                  placeholder="Enter Phone No"
                  v-model="membership.phone"
                  id="phone"
                  class="form-control input"
                  required
                />
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-12">
                <div class="form-group">
                  <label for="">Street Address</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Street Address"
                    v-model="address.street"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label for="">Apartment #</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Apartment #"
                    v-model="address.apartment"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label for="">City</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="City"
                    v-model="address.city"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label for="">State</label>
                  <select v-model="address.state" class="form-control">
                    <option value="">Select state</option>
                    <option
                      :value="state"
                      v-for="state in getUsaStates"
                      :key="state"
                    >
                      {{ state }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label for="">Zip</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Zip"
                    v-model="address.zip"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="title">Membership Type</label>
              <select
                class="form-control"
                v-model="membership.planType"
                required
              >
                <option value="">Select one</option>
                <option
                  v-for="plan in getPlantypeList"
                  :key="plan.id"
                  :value="plan.value"
                >
                  {{ plan.name }}
                </option>
              </select>
            </div>
            <!-- <div class="card mb-3" v-if="membership.planType == 'weekendnew'">
              <div class="card-header">
                Add-Ons
              </div>
              <div class="card-body">
                <div class="form-group">
                  <div class="d-flex mb-2">
                    <input
                      class="radio"
                      v-model="addon"
                      id="addon"
                      type="radio"
                      :value="true"
                    />
                    <label for="addon" class="ml-2 text-success"
                      >Yes, I want Sprinter fleet access upgrade +
                      $100/month</label
                    >
                  </div>
                  <div class="d-flex">
                    <input
                      class="radio"
                      v-model="addon"
                      id="no-addon"
                      type="radio"
                      :value="false"
                    />
                    <label for="no-addon" class="ml-2 text-danger"
                      >No Thank you, I just want to access TAXA's/Scout's</label
                    >
                  </div>
                </div>
              </div>
            </div> -->

            <div class="form-group pt-2 pb-2 card card-body border-0">
              <StripeElementCard
                ref="elementRef"
                id="card-number"
                :pk="pulishableKey"
                @token="tokenCreated"
                :elementStyle="{
                  base: {
                    color: '#000',
                    fontWeight: '500',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
                    ':-webkit-autofill': {
                      color: '#fce883',
                    },
                    '::placeholder': {
                      color: '#000',
                    },
                  },
                }"
              />
            </div>
            <div class="mb-2 card card-body">
              <div class="row">
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="coupon"
                    id="coupon-code"
                    placeholder="Promo Code"
                  />
                </div>
                <div class="col-2">
                  <Button
                    :loading="applying"
                    @click="
                      applied = false;
                      coupon = '';
                    "
                    label="Remove"
                    v-if="applied"
                  />
                  <Button
                    :loading="applying"
                    @click="applyCoupon"
                    label="Apply"
                    v-else
                  />
                </div>
              </div>
              <div v-if="applied && couponData.id" class="row">
                <div class="col-12" style="margin-top: 0">
                  <div class="font-weight-bold">
                    {{ couponData.commitment }}
                  </div>
                  <div class="font-weight-bold">
                    {{ couponData.description }}
                    <br />
                    <div class="font-weight-bold">
                      Initiation discount: ${{ couponData.discountInitiation }}
                    </div>
                    <div class="font-weight-bold">
                      Monthly discount: ${{ couponData.discountMonthly }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <!-- signature pad -->
              <label for="">Please sign below</label>
              <div class="border">
                <VueSignaturePad
                  width="100%"
                  height="250px"
                  ref="signaturePad"
                  :options="{ onEnd }"
                />
              </div>
              <div class="row mt-2">
                <div
                  class="col-sm-12 col-md-4 offset-md-8 text-right align-right"
                >
                  <Button
                    @click="clearSignature"
                    label="Clear"
                    id="clearSignature"
                    :type="'button'"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <span role="button" @click="termsDialog = true">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="status"
                  name="checkbox-1"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  accept the terms & condition
                  <i class="fa fa-external-link"></i>
                </b-form-checkbox>
              </span>
            </div>
            <div class="form-group mt-2">
              <Button
                :loading="loading"
                label="Submit"
                id="send-email-button"
              ></Button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <b-modal
      title="Terms and Conditions"
      v-model="termsDialog"
      size="lg"
      hide-footer
    >
      <div>
        <Terms
          :planType="getPlan"
          :name="membership.fname + ' ' + membership.lname"
          :phone="membership.phone"
          :email="membership.email"
          :dob="getDOB"
          :address="getAddress"
        />

        <div class="mt-5 mb-3" style="margin: 0 5%">
          <Button
            @click="
              () => {
                status = 'accepted';
                termsDialog = false;
              }
            "
            label="Close"
            type="button"
          ></Button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Button from "@/components/ButtonDefault";
import { storage } from "@/modules/database";
import { mapGetters } from "vuex";
import moment from "moment";
import { StripeElementCard } from "@vue-stripe/vue-stripe";
import axios from "axios";
import Terms from "../components/Terms.vue";

export default {
  data() {
    return {
      pulishableKey:
      "pk_live_51Jyrb3GIcoCn5XsxSUI4ji83DCh8cXKwOYWWmFpTvOpMKfL81PhizNjiDLtqM1QkJVTBp6NDwmaYxnQnfqQRD7f5007XgQfjEU",
      // pulishableKey: "pk_test_kpjrsyBp09wT8B8y6UIHXPxD",
      coupon: "",
      applying: false,
      applied: false,
      couponData: {},
      membership: {
        fname: "",
        lname: "",
        dob: "",
        front_dl: "",
        back_dl: "",
        front_insurance: "",
        back_insurance: "",
        email: "",
        countryCode: "+1",
        phone: "",
        address: "",
        planType: "",
        priceType: "",
        signature: "",
      },
      refered_by: "",
      adItem: "",
      selectedByList: [
        {
          name: "None",
          value: "",
        },
        {
          name: "Sales Representative",
          value: "sales_rep",
        },
        {
          name: "Advertisement",
          value: "advertisement",
        },
        {
          name: "Refferal",
          value: "refferal",
        },
        {
          name: "Other",
          value: "refered_by",
        },
      ],
      itemsAd: [
        {
          name: "Facebook",
          value: "facebook",
        },
        {
          name: "Instagram",
          value: "instagram",
        },
        {
          name: "Flyer",
          value: "flyer",
        },
        {
          name: "Other",
          value: "other",
        },
      ],
      refered_by_name: "",
      showImage: false,
      imageShow: "",
      formLoader: false,
      supportList: [],
      loading: false,
      termsDialog: false,
      status: "accepted",
      year: "",
      month: "",
      day: "",
      address: {
        street: "",
        apartment: "",
        city: "",
        state: "Washington",
        zip: "",
      },
      addon: false,
      plans: [],
      getPlantypeList: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    model: {
      get() {
        return this.support.DateandTime;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    getYear() {
      // get last 100 years
      let years = [];
      for (let i = moment().year() - 24; i > moment().year() - 120; i--) {
        years.push(i);
      }
      return years;
    },
    getMonth() {
      // get last 12 months
      let months = [];
      for (let i = 1; i <= 12; i++) {
        if (i < 10) {
          i = "0" + i;
        }
        months.push(i);
      }
      return months;
    },
    getDay() {
      // get last 31 days
      let days = [];
      for (let i = 1; i <= 31; i++) {
        if (i < 10) {
          i = "0" + i;
        }
        days.push(i);
      }
      return days;
    },
    getUsaStates() {
      return [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ];
    },
    getDOB() {
      const dob = `${this.year}-${this.month}-${this.day}`;
      // get timestamp from dob
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.membership.dob = dob; //moment(dob).format("YYYY-MM-DD"); //.valueOf() / 1000;
      return `${this.month}-${this.day}-${this.year}`;
    },
    getAddress() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.membership.address = `${this.address.street} ${this.address.apartment} ${this.address.city} ${this.address.state} ${this.address.zip}`;
      return `${this.address.street} ${this.address.apartment} ${this.address.city} ${this.address.state} ${this.address.zip}`;
    },
    getPlan() {
      const planSelected = this.plans.find(
        (plan) => plan.id === this.membership.planType
      );
      if (planSelected) {
        return planSelected.title + " " + planSelected.subtitle;
      }
      return "Not Found";
    },
  },
  components: {
    Button,
    StripeElementCard,
    Terms,
  },
  mounted() {
    this.parseQuery();
    this.getData();
  },
  methods: {
    getData() {
      axios
        .get(`https://api-prod-dot-pay-routeline.uc.r.appspot.com/api/v1/plan`)
        // .get(`https://pay-routeline.uc.r.appspot.com/api/v1/plan`)
        .then((res) => {
          this.plans = res.data;
          let newplan = [];
          this.plans.forEach((plan) => {
            const desc = plan.description?.split("~");
            newplan.push({
              ...plan,
              name:
                plan.title +
                " " +
                plan.subtitle +
                ` (${desc?.[0] || ""}) + Taxes`,
              value: plan.id,
            });
          });
          this.getPlantypeList = newplan;
        });
    },
    uploadFile(file, type) {
      const fileName = `document-${type}-${new Date().getTime()}`;
      const storageRef = storage.ref(`/routeline-subscription/${fileName}`);
      const uploadFile = storageRef.put(file);

      return new Promise((resolve, reject) => {
        uploadFile.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
          },
          (error) => {
            console.log(error);
            reject();
          },
          () => {
            uploadFile.snapshot.ref.getDownloadURL().then((downloadURL) => {
              resolve({ downloadURL, type });
            });
          }
        );
      });
    },
    getTime(time) {
      return moment(time * 1000).format("lll");
    },
    getUserName() {},
    changeCountryCode({ dialCode }) {
      this.membership.countryCode = "+" + dialCode;
    },
    validateAndAccept() {
      this.loading = true;
      if (!this.membership.signature) {
        this.$root.toast("Please sign above");
        this.loading = false;
        return;
      }
      // check usa zip code is valid
      if (this.address.zip.length !== 5) {
        if (!/^\d{5}(?:[-\s]\d{4})?$/.test(this.address.zip)) {
          this.$root.toast("Please enter valid zip code");
          this.loading = false;
          return;
        }
        return;
      }

      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.membership.signature) {
        this.$root.toast("Please sign above");
        this.loading = false;
        return;
      }

      this.$refs.elementRef.submit();
    },
    tokenCreated(token) {
      if (!token) {
        this.loading = false;
        this.$root.toast("Please check card details");
        return;
      }

      this.loading = true;
      this.saveMembership(token);
    },
    async saveMembership(token) {
      try {
        const uid = this.user?.uid || 0;

        await axios.post(
          "https://api-prod-dot-pay-routeline.uc.r.appspot.com/api/v1/membership",
          // "https://pay-routeline.uc.r.appspot.com/api/v1/membership",
          {
            firstName: this.membership.fname,
            lastName: this.membership.lname,
            dob: this.membership.dob,
            email: this.membership.email,
            referredBy: `${this.refered_by} ${this.adItem}, ${this.refered_by_name}`,
            phone: this.membership.countryCode + this.membership.phone,
            createdBy: uid.toString(),
            address: {
              street: this.address.street,
              apartment: this.address.apartment,
              city: this.address.city,
              state: this.address.state,
              zip: this.address.zip.toString(),
            },
            plan: this.membership.planType.toString(),
            signature: this.membership.signature,
            cardID: token.card.id,
            token: token.id,
            coupon: this.applied ? this.coupon : "",
          }
        );

        const Name = this.membership.fname + " " + this.membership.lname;
        const { email, phone, address } = this.membership;
        const dBirth = moment(this.membership.dob).format("MM-DD-YYYY");

        await this.mutation(Name, email, phone, dBirth, address);

        this.$root.toast("Membership Subscribed");
        this.membership = {
          fname: "",
          lname: "",
          dob: "",
          front_dl: "",
          back_dl: "",
          front_insurance: "",
          back_insurance: "",
          email: "",
          countryCode: "+1",
          phone: "",
          address: "",
          planType: "",
          priceType: "",
          signature: "",
        };
        this.year = "";
        this.month = "";
        this.day = "";
        this.address = {
          street: "",
          apartment: "",
          city: "",
          state: "Washington",
          zip: "",
        };
        this.status = "not-accepted";
        this.$router.push("/success");
      } catch (error) {
        if (error.response.data.code == "customer_tax_location_invalid") {
          this.$root.toast("Please enter valid zip code");
          return;
        }
        if (error.response.data.code == "auth/invalid-phone-number") {
          this.$root.toast("Please enter valid phone number");
          return;
        }
        this.$root.toast("Error Subscribing");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    onEnd() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      if (isEmpty) {
        return;
      }
      this.membership.signature = data;
    },
    clearSignature() {
      this.membership.signature = "";
      this.$refs.signaturePad.clearSignature();
    },
    parseQuery() {
      const query = this.$route.query;
      this.membership.planType = Number(query.plan) || "";
      // if (query.plan === "anyday") {
      //   this.membership.planType = "weekendnew";
      // }
      // if (query.plan === "anyday-prepaid") {
      //   this.membership.planType = "weekend-once";
      // }
      // if (query.plan === "weekday") {
      //   this.membership.planType = "weekday";
      // }
      // if (query.plan === "weekday-prepaid") {
      //   this.membership.planType = "weekday-once";
      // }
      // if (query.plan === "weekday100") {
      //   this.membership.planType = "weekday100new";
      // }
    },
    async mutation(name, email, phone, dob, address) {
      const data = `mutation {\n    create_item(\n    item_name: \"${name}\",\n    board_id: 2088281871,\n    group_id: new_group,\n    column_values :\"{\\\"status\\\" : {\\\"label\\\" : \\\"Member\\\"},\\\"status9\\\" : {\\\"label\\\" : \\\"Active\\\"},\\\"text3\\\" : \\\"${dob}\\\",\\\"phone\\\" : {\\\"phone\\\" : \\\"${phone}\\\", \\\"countryShortName\\\" : \\\"US\\\"},\\\"email\\\":{\\\"email\\\":\\\"${email}\\\",\\\"text\\\":\\\"${email}\\\"},\\\"text\\\" : \\\"${address}\\\"}\"\n    )\n    {\n    id,\n    column_values{\n        id\n        value\n        text\n    }\n  }\n}`;

      try {
        return await fetch("https://api.monday.com/v2", {
          method: "POST",
          headers: {
            Authorization:
              "eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjE3MjgxMjI2MSwidWlkIjozMTcyNDU2NiwiaWFkIjoiMjAyMi0wNy0yOVQwNzo1MjoyMC45MDFaIiwicGVyIjoibWU6d3JpdGUiLCJhY3RpZCI6MTA3MTIyNDMsInJnbiI6InVzZTEifQ.l3Z6ptCRPEUYJbAYqbvQEPDlRduUoPYeMeXjjFbGFz0",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: data,
          }),
        });
      } catch (error) {
        console.log(error);
        return true;
      }
    },
    async applyCoupon() {
      if (!this.coupon) {
        this.$root.toast("Please enter a valid coupon", "error");
        return;
      }
      try {
        this.applying = true;
        const response = await axios.post(
          `https://api-prod-dot-pay-routeline.uc.r.appspot.com/api/v1/coupon-member-apply/${this.coupon.toUpperCase()}`,
          // `https://pay-routeline.uc.r.appspot.com/api/v1/coupon-member-apply/${this.coupon.toUpperCase()}`
        );
        this.couponData = response.data.data;
        this.applied = true;
        this.$root.toast("Coupon Applied", "success");
      } catch (error) {
        this.$root.toast(
          error?.response?.data?.message || "Something went wrong.",
          "error"
        );
      } finally {
        this.applying = false;
      }
    },
  },
};
</script>

<style>
/* .addinput {
  background-color: #e9ecef;
  border: 0;
  color: black;
} */
.radio {
  width: 25px;
  height: 25px;
}
.input {
  height: 50px;
  opacity: 1;
}
.color-primary {
  background-color: var(--primary-color);
}
.attachment-image {
  display: inline;
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin: 2px;
  border: 1px solid var(--primary-color);
}
</style>
